export default __webpack_public_path__ + "static/media/s20.acba6bf5.png";